import React, { Component } from 'react';

class PopoverInner extends Component {
  static defaultProps = {
    isOpen: false,
    close: () => {},
    open: () => {},
    childToggle: null,
  }

  renderChildren = () => {
    const {
      children,
      childToggle,
      open,
      close,
      isOpen,
    } = this.props;
    let decoratedChildren = children;
    if (childToggle) {
      const child = React.Children.only(children);
      const decoratedProps = {
        open,
        close,
        isOpen,
        onToggle: close,
      };

      Object.entries(childToggle).forEach(([propName, toggleCheck]) => {
        decoratedProps[propName] = (...args) => {
          if (toggleCheck(...args)) {
            close();
          }

          return child.props[propName](...args);
        };
      });

      decoratedChildren = React.cloneElement(child, decoratedProps, child.children);
    }

    return decoratedChildren;
  };

  render() {
    return (
      <div>
        {this.renderChildren()}
      </div>
    );
  }
}

export default PopoverInner;
